import Header from "./components/Header";
import Main from "./components/Main";
import Footer from "./components/Footer";
import "bulma/css/bulma.css";

const App = () => {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
};

export default App;